import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  static targets = ['installationHidden', 'deviceAutocomplete', 'deviceInput']

  connect() {
    this.installationChanged();
  }

  installationChanged() {
    const installationId = this.installationHiddenTarget.value;
    const deviceContainer = this.deviceAutocompleteTarget;
    const deviceInput = this.deviceInputTarget;

    if (installationId) {
      const newUrl = `/en/devices/search?installation_id=${installationId}`;
      deviceContainer.setAttribute('data-autocomplete-url-value', newUrl);
      deviceContainer.setAttribute('data-autocomplete-url', newUrl);
      deviceInput.removeAttribute('disabled');
      deviceContainer.classList.remove('opacity-50');
    } else {
      deviceInput.setAttribute('disabled', 'disabled');
      deviceInput.value = '';
      deviceContainer.classList.add('opacity-50');
    }
  }
}
